module.exports = __webpack_public_path__ + "static/media/play-poki.a4e5c1b0.svg";